import {
  fallbackSchema,
  recoverConfigSchema,
  scenarioSchema,
} from "@redotech/redo-marketing-templates-common/recover-config";
import { objectId } from "@redotech/rpc/ext";
import * as z from "zod";

export const updateRecoverConfig = {
  name: "updateRecoverConfig" as const,
  input: z.object({
    id: z.string(),
    name: z.string().optional(),
    discountId: objectId().nullish(),
    agentName: z.string().optional(),
    brandName: z.string().optional(),
    supportEmail: z.string().optional(),
    agentOutreachEnabled: z.boolean().optional(),
    outreachTemplate: z.string().optional(),
    /** Null routes all replies to `fallback`. */
    replyTemplate: z.string().nullish(),
    /** @deprecated Accepted from stale clients but ignored; scenarios are no longer written. */
    scenarios: z.array(scenarioSchema).optional(),
    fallback: fallbackSchema.optional(),
    ageGateYears: z.number().int().positive().nullable().optional(),
  }),
  output: recoverConfigSchema,
};
